<template>
  <el-select
    v-if="singleData"
    v-model="channel"
    @change="getCty"
    filterable
    clearable
    collapse-tags
    placeholder="选择渠道"
    size="small"
  >
    <el-option-group v-for="group in options" :key="group.label" :label="group.label">
      <el-option
        v-for="(item,index) in group.options"
        :key="index"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-option-group>
  </el-select>
  <el-select
    v-else
    v-model="channel"
    @change="getCty"
    filterable
    clearable
    multiple
    collapse-tags
    placeholder="批量选择渠道"
    size="small"
  >
    <el-option-group v-for="group in options" :key="group.label" :label="group.label">
      <el-option
        v-for="(item,index) in group.options"
        :key="index"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-option-group>
  </el-select>
</template>

<script>
import httpApi from "@/http/api";
export default {
  name: "channel",
  props: {
    channels: { String },
    single: { Boolean }
  },
  data() {
    return {
      options: [],
      channel: this.channels,
      singleData: this.single
    };
  },
  methods: {
    getCty(e) {
      this.$emit("getCty", e);
    },
    init() {
      let that = this;
      that.options = [];
      httpApi.listChannelForCustomer({ params: {} }).then(res => {
        if (res.data.code == "ok") {
          (res.data.data || []).forEach(element => {
            that.options.push({ label: element.label, options: element.list });
          });
        }
      });
    }
  },
  created() {
    this.init();
  },
  watch: {
    channels: function(newVal) {
      this.channel = newVal;
    }
  }
};
</script>

<style>
.el-select-group__title{
    color: #000!important;
    font-weight: 600!important;
    font-size: 14px!important;
}
</style>
